import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import { skeletonStyle } from "../Skeletons/skeletons.js";

/**
 * Per-turn widths, varied so the placeholder reads as a conversation rather
 * than a stack of identical blocks.
 */
const SKELETON_TURNS = [
  { promptWidth: "w-2/5", replyLineWidths: ["w-full", "w-11/12", "w-3/5"] },
  { promptWidth: "w-1/2", replyLineWidths: ["w-full", "w-4/5"] },
] as const;

/**
 * Stands in for a thread while its history loads: a prompt bubble and a few
 * reply lines per turn, so the conversation's shape appears before its content.
 */
export const ChatThreadSkeleton: FC<{ className?: string }> = (props) => (
  <div
    role="status"
    className={twMerge("flex flex-col gap-6", props.className)}
  >
    {SKELETON_TURNS.map((turn, turnIndex) => (
      <div key={turnIndex} className="flex flex-col gap-4">
        <div
          className={skeletonStyle({
            className: twMerge("h-9 rounded-lg bg-muted", turn.promptWidth),
          })}
        />
        <div className="flex flex-col gap-2.5">
          {turn.replyLineWidths.map((lineWidth, lineIndex) => (
            <div
              key={lineIndex}
              className={skeletonStyle({
                className: twMerge("h-2.5", lineWidth),
              })}
            />
          ))}
        </div>
      </div>
    ))}
    <span className="sr-only">Loading conversation...</span>
  </div>
);
